<form [formGroup]="buitenlandseBronheffing">
    <div *ngIf="bronheffingBtl.length > 0">
        <div formArrayName="bronheffingBtl">
            <div *ngFor="let item of bronheffingBtl.controls; let i = index; "
                          [formGroupName]="i" class="row">
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Rekeningnummer' : ''"
                                                class="col-auto custom-input-250"
                                                formControlName="rekeningNummer"
                                                id="rekeningNummer"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-select-form-control (change)="saveForm()"
                                                  [label]="i === 0 ? 'Land' : ''"
                                                  [options]="optionsLandcodes"
                                                  class="col-auto custom-input-175"
                                                  formControlName="landCode"
                >
                </snelstart-ui-select-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Dividend box 3' : ''"
                                                  align="right"
                                                  class="col-auto custom-input-150"
                                                  formControlName="buitenlandsDividendbox3"
                                                  id="buitenlandsDividendbox3"
                                                  prefix="€"

                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Bronbelasting box 3' : ''"
                                                  align="right"
                                                  class="col-auto custom-input-150"
                                                  formControlName="bronbelastingOpDividendbox3"
                                                  id="bronbelastingOpDividendbox3"
                                                  prefix="€"

                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Dividend box 2' : ''"
                                                  align="right"
                                                  class="col-auto custom-input-150"
                                                  formControlName="buitenlandsDividendbox2"
                                                  id="buitenlandsDividendbox2"
                                                  prefix="€"

                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Bronbelasting box 2' : ''"
                                                  align="right"
                                                  class="col-auto custom-input-150"
                                                  formControlName="bronbelastingOpDividendbox2"
                                                  id="bronbelastingOpDividendbox2"
                                                  prefix="€"

                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-button (click)="verwijderRijBronheffingBtl(i)"
                                     [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                     icon="trash"
                                     iconType="light"
                                     id="buttonDeleteKosten"
                                     size="medium"
                                     type="secondary"
                >
                </snelstart-ui-button>
            </div>
        </div>
    </div>
</form>

<div *ngIf="bronheffingBtl.length === 0">
    <snelstart-ui-button (click)="addRijBronheffingBtl()" class="snelstart-ui-button" icon="plus"
                         type="link">Bronbelasting box 3 en/of box 2 invullen
    </snelstart-ui-button>
</div>
<div *ngIf="bronheffingBtl.length > 0">
    <snelstart-ui-button (click)="addRijBronheffingBtl()" class="snelstart-ui-button" icon="plus"
                         type="link">Bronbelasting toevoegen
    </snelstart-ui-button>
</div>

